<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BillingFulfillmentCML",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  